import createVueComponent from '../createVueComponent';

const ChevronLeftCircle = createVueComponent('ChevronLeftCircleIcon', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['path', { d: 'm14 16-4-4 4-4', key: 'ojs7w8' }],
]);

export default ChevronLeftCircle;
